var render = function render(){var _vm=this,_c=_vm._self._c;return (this.isAuthenticated)?_c('section',[_vm._v("\n  Logged in as "),_c('strong',[_vm._v(" "+_vm._s(this.getUsername)+" ")]),_c('button',{staticClass:"button is-primary is-small",on:{"click":_vm.logoutAndAlert}},[_vm._v("\n    Logout\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }